import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import $ from 'jquery';
import moment from 'moment';
import { Moment } from 'moment';
import { fromEvent, ReplaySubject } from 'rxjs';
import {
    filter,
    startWith,
    takeWhile,
    tap,
    throttleTime
} from 'rxjs/operators';
import Tabulator from 'tabulator-tables';
import { ITask } from '../../../lookups/ITask';
import {
    DisplayMessageMinimum,
    Process,
    ResponseStatus
} from '../../../shared';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { UnsavedChangesService } from '../../../shared/modal-dialog';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { TabulatorService } from '../../../tabulator.service';
import { IFixedPrice } from '../../IFixedPrice';

@Component({
    selector: 'ef-fixed-price',
    templateUrl: './fixed-price.component.html',
    styleUrls: ['./fixed-price.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FixedPriceComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() public process: Process;
    private _errors: Array<string>;
    downloadOptions: { label: string; icon: string; command: () => void }[];
    sortedInvoices: IFixedPrice[] = [];
    @Input() public set errors(value: Array<string>) {
        this.log.debug({
            type: 'FixedPricePresenterComponent:errors:set',
            value
        });
        this._errors = value;
        if (value && value.length) {
            this.errorHelpText = value
                .reduce((a, c) => a + c + '\r\n', '')
                .trim();
        } else {
            this.errorHelpText = '';
        }
    }
    public get errors(): Array<string> {
        return this._errors;
    }
    private _selectedError: IShowErrors;
    @Input() public set selectedError(value: IShowErrors) {
        this.log.debug({
            type: 'FixedPricePresenterComponent:selectedError:set',
            value
        });
        if (this.process) {
            if (value.MsgProcessID === this.process.ProcessID) {
                if (this._selectedError && this._selectedError.MsgEntityID) {
                    const prevRow = this.tabFixedPrice
                        .getRows()
                        .find(
                            row =>
                                row.getData().UniqueID ===
                                this._selectedError.MsgEntityID
                        );
                    if (prevRow) {
                        prevRow.getElement().classList.remove('highlight');
                    }
                }
                this._selectedError = value;
                const theRow = this.tabFixedPrice
                    .getRows()
                    .find(row => row.getData().UniqueID === value.MsgEntityID);
                if (theRow) {
                    theRow.scrollTo();
                    theRow.getElement().classList.add('highlight');
                    // theRow.getElement().css({'background-color': 'green'});
                    this.log.debug({
                        type: 'FixedPricePresenterComponent:selectedError:set',
                        rowElement: theRow.getElement()
                    });
                }
            }
        }
    }
    public get selectedError(): IShowErrors {
        return this._selectedError;
    }

    toggleChecked: boolean;
    CNTaskDropdownText = 'Charge Numbers';
    taskLevelToggleText = 'Include sub tasks: [ OFF ]';
    public FPInvoicesSubject = new ReplaySubject<Array<IFixedPrice>>(1);
    private _fpinvoices: Array<IFixedPrice>;
    @Input('fpinvoices') set fpinvoices(value: Array<IFixedPrice>) {
        // INFO: it would appear @input values come through as immutable, tabulator requires mutable data

        if (value) {
            this._fpinvoices = value.map(x => ({ ...x }));
            this.loadingData = false;
            this.FPInvoicesSubject.next(this._fpinvoices);
        }
    }
    get fpinvoices(): Array<IFixedPrice> {
        return this._fpinvoices;
    }

    @Input() tasks: Array<ITask>;
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Output() selectStartDate = new EventEmitter<string>();
    @Output() selectEndDate = new EventEmitter<string>();
    @Output() selectTask = new EventEmitter<Array<ITask>>();
    @Output() toggleTaskLevel = new EventEmitter<boolean>();
    @Output() applyMultiUpdateClicked = new EventEmitter<any>();
    @Output() selected = new EventEmitter<IFixedPrice>();
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    public tabFixedPrice;
    public filterFormGroup: UntypedFormGroup;
    public updateFormGroup: UntypedFormGroup;
    private componentActive = true;
    private currentPage: number;
    public selectColumnWidth = 50;
    public errorHelpText = '';
    public selectedRowsCheckbox = { checked: false, indeterminate: false };
    public taskFilters: any[] = [];
    public mu_invoiceAmount = '';
    public loadingData = true;
    public selectedStartDate: Date; // = this.startDate;
    public selectedEndDate: Date; // = this.endDate;
    public selectedStartString: string; // = this.startDate;
    public selectedEndString: string; // = this.endDate;

    currentCell: any;

    @ViewChild('selectAll', { read: ElementRef, static: true })
    selectAllButton: ElementRef;
    @ViewChild('cbxColumnHeader', { static: true })
    cbxColumnHeader: MatCheckbox;
    @ViewChild('applyMulti', { read: ElementRef, static: true })
    applyMultiButton: ElementRef;

    @Output() DeleteFixedPrice = new ReplaySubject<any>(1);

    constructor(
        private log: LoggingService,
        private tabService: TabulatorService,
        private confirmservice: UnsavedChangesService
    ) {
        this.filterFormGroup = new UntypedFormGroup({
            startDate: new UntypedFormControl(null),
            endDate: new UntypedFormControl(null),
            tasks: new UntypedFormControl(null),
            taskLevelEntry: new UntypedFormControl(true),
            contractTypes: new UntypedFormControl(null)
        });

        this.updateFormGroup = new UntypedFormGroup({
            scheduledAmount: new UntypedFormControl(null)
        });
    }

    ngOnDestroy() {
        this.componentActive = false;
    }

    public downloadTable(type) {
        this.tabFixedPrice.download(
            type,
            `${this.process.ProcessTitle}_${moment(new Date()).format(
                'MM-DD-YYYY'
            )}.${type}`,
            { sheetName: 'Fixed Price Entry' }
        );
    }
    ngOnInit() {
        this.downloadOptions = [
            {
                label: 'CSV',
                icon: 'pi pi-download',
                command: () => this.downloadTable('csv')
            },
            {
                label: 'Excel',
                icon: 'pi pi-download',
                command: () => this.downloadTable('xlsx')
            }
        ];
        this.setupSubscriptions();
    }
    setupSubscriptions() {
        this.FPInvoicesSubject.pipe(
            takeWhile(() => this.componentActive),
            filter(x => !!x && x.length > 0)
        ).subscribe(fpinvoices => {
            if (fpinvoices) {
                if (this.tabFixedPrice) {
                    this.sortedInvoices = fpinvoices.sort((a, b) => {
                        if (a.TaskLongName === b.TaskLongName) {
                            return 0;
                        }
                        if (typeof a.TaskLongName === typeof b.TaskLongName) {
                            return a.TaskLongName < b.TaskLongName ? -1 : 1;
                        }
                        return typeof a.TaskLongName < typeof b.TaskLongName
                            ? -1
                            : 1;
                    });
                    this.tabFixedPrice.replaceData(this.sortedInvoices);
                } else {
                    this.sortedInvoices = fpinvoices.sort((a, b) => {
                        if (a.TaskLongName === b.TaskLongName) {
                            return 0;
                        }
                        if (typeof a.TaskLongName === typeof b.TaskLongName) {
                            return a.TaskLongName < b.TaskLongName ? -1 : 1;
                        }
                        return typeof a.TaskLongName < typeof b.TaskLongName
                            ? -1
                            : 1;
                    });
                    this.createTabulator(this, this.sortedInvoices, []);
                }
            }
        });

        /*FormGroup for the filters which allows you to track the
    value and validity state of the filters FormControl instances.*/
        this.filterFormGroup = new UntypedFormGroup({
            endDate: new UntypedFormControl(
                moment(this.endDate).format('MM/DD/YYYY')
            ),
            startDate: new UntypedFormControl(
                moment(this.startDate).format('MM/DD/YYYY')
            ),
            tasks: new UntypedFormControl(null),
            taskLevelEntry: new UntypedFormControl(true),
            contractTypes: new UntypedFormControl(null)
        });

        /*FormGroup for the multiupdate which allows you to track the
    value and validity state of the multiupdate FormControl instances.*/
        this.updateFormGroup = new UntypedFormGroup({
            scheduledAmount: new UntypedFormControl(null)
        });

        // Catches when the value of the startdate filter changes
        this.filterFormGroup.controls['startDate'].valueChanges
            .pipe(
                startWith(this.startDate),
                takeWhile(_ => this.componentActive)
            )
            .subscribe(x => {
                try {
                    if (moment(x).isValid()) {
                        this.loadingData = true;
                        this.selectStartDate.emit(
                            moment(x).format('MM/DD/YYYY')
                        );
                        this.selectedStartDate = new Date(
                            moment(x).format('MM/DD/YYYY')
                        );
                    }

                    // this.selectedStartString
                } catch (e) {
                    this.log.debug({
                        type: 'FixedPriceComponent:startDate:valueChanges:subscribe:catch',
                        e
                    });
                }
            });

        // Catches when the value of the enddate filter changes
        this.filterFormGroup.controls['endDate'].valueChanges
            .pipe(
                startWith(this.endDate),
                takeWhile(_ => this.componentActive)
            )
            .subscribe(x => {
                try {
                    if (moment(x).isValid()) {
                        this.loadingData = true;
                        this.selectEndDate.emit(moment(x).format('MM/DD/YYYY'));
                        this.selectedEndDate = new Date(
                            moment(x).format('MM/DD/YYYY')
                        );
                    }
                } catch (e) {
                    this.log.debug({
                        type: 'FixedPriceComponent:endDate:valueChanges:subscribe:catch',
                        e
                    });
                }
            });

        // Catches when the value of the task filter changes
        this.filterFormGroup.controls['tasks'].valueChanges
            .pipe(
                takeWhile(() => this.componentActive),
                startWith([]),
                tap(value =>
                    this.log.debug({
                        type: 'FixedPriceComponent:tasks:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'FixedPriceComponent:tasks:valueChanges:subscribe',
                    value
                });
                this.loadingData = true;
                this.selectTask.emit(value);
                if (value) {
                    this.filterData(value);
                }
            });

        // Catches when the value of the task filter changes
        this.filterFormGroup.controls['contractTypes'].valueChanges
            .pipe(
                takeWhile(() => this.componentActive),
                startWith([]),
                tap(value =>
                    this.log.debug({
                        type: 'FixedPriceComponent:contractTypes:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'FixedPriceComponent:contractTypes:valueChanges:subscribe',
                    value
                });
                this.loadingData = true;
                this.selectTask.emit(value);
                if (value) {
                    this.filterData(value);
                }
            });

        // Click event for multiupdate
        fromEvent(this.applyMultiButton.nativeElement, 'click')
            .pipe(
                tap(_ =>
                    this.log.debug({
                        type: 'FixedPricePresentersComponent:applyUpdatesButton:tap:click'
                    })
                ),
                takeWhile(_ => this.componentActive),
                throttleTime(1000)
            )
            .subscribe(button => {
                this.log.debug({
                    type: 'FixedPriceComponent:applyMultiButton:ApplyClick'
                });
                const rows = this.tabFixedPrice.getSelectedRows();
                rows.forEach(row => {
                    row.update({
                        Status: { StatusCode: ResponseStatus.Loading }
                    });
                });

                const selectedData: Array<IFixedPrice> =
                    this.tabFixedPrice.getSelectedData();
                const controls = this.updateFormGroup.controls;
                selectedData.forEach(r => {
                    if (controls['scheduledAmount'].value) {
                        r.ScheduledAmount = controls['scheduledAmount'].value;
                    }
                });
                this.currentPage = this.tabFixedPrice.getPage();
                this.applyMultiUpdateClicked.emit(
                    {
                        data: selectedData.map(r => {
                            const id = r.UniqueID; // should be uniqueID
                            const data = this.fpinvoices.find(
                                x => x.UniqueID === id
                            );
                            return {
                                ...data, // old values
                                ...r // applying new values
                            };
                        }),
                        type: 'Multi'
                    }
                );

                this.updateFormGroup.reset();
            });
    }
    ngAfterViewInit(): void {
        this.log.verbose({ type: 'FixedPriceComponent:ngAfterViewInit' });

        this.tabService.tabulator = $('#tabFixedPrice');


    }

    showAll() {
        if (this.fpinvoices.length > 0) {
            this.tabFixedPrice.setData(this.fpinvoices);
        }
    }

    clearLinesWithout$() {
        if (this.fpinvoices.length > 0) {
            let filteredFPInvoices;
            filteredFPInvoices = this.fpinvoices.filter(
                x =>
                    x.InvoiceAmount != null ||
                    x.ScheduledAmount != null ||
                    x.ScheduleDate == null
            );
            this.tabFixedPrice.setData(filteredFPInvoices);
        }
    }

    filterData(filters: any[]) {
        if (this.tabFixedPrice) {
            this.tabFixedPrice.clearFilter(true);

            const filtersToApply: Array<
                Array<{
                    field: string;
                    type: string;
                    value: any;
                }>
            > = [[]];

            if (filters && filters.length > 0) {
                filters.forEach(v => {
                    filtersToApply[0].push({
                        field: 'TaskLongName',
                        type: '=',
                        value: v.TaskLongName
                    });
                });
            }

            this.tabFixedPrice.setFilter(filtersToApply);
            this.loadingData = false;
        }
    }

    // Creates the tabulator with status, selected, and any page specific columns
    private createTabulator(
        fp: FixedPriceComponent,
        fpinvoices: any[],
        errors: Array<string>
    ) {
        let headerClicked = false;

        const editCheck = function (cell) {
            const data = cell.getRow().getData();
            return !data.ScheduleDate;
        };

        this.tabFixedPrice = new Tabulator('#tabFixedPrice', {
            placeholder: 'No Data Available',
            height: '55vh',
            layout: 'fitColumns',
            data: fpinvoices,
            index: 'UniqueID',
            columns: [
                // 0
                {
                    title: 'Id',
                    field: 'UniqueID',
                    frozen: true,
                    visible: false
                },
                // 1 Status
                {
                    title: '',
                    field: 'Status',
                    download: false,
                    width: fp.selectColumnWidth,
                    formatter: (cell, params, onRendered) => {
                        const status = cell.getValue();
                        if (status) {
                            switch (status.StatusCode) {
                                case 1:
                                    return '<div><i class="material-icons green">check_circle</i></div>';
                                case 2:
                                    return '<div><i class="material-icons yellow">report_problem</i></div>';
                                case 3:
                                    return '<div><i class="material-icons red" (click)="setError()">highlight_off</i></div>';
                                case 4:
                                    return '<div><i class="material-icons red" (click)="setError()">highlight_off</i></div>';
                                case 5:
                                    return '<div><i class="material-icons red" (click)="setError()">highlight_off</i></div>';
                                case 6:
                                    return '<div><i class="material-icons red" (click)="setError()">highlight_off</i></div>';
                                case 99:
                                // return '<div><i class="fa fa-spinner fa-spin"></i></div>';
                                default:
                                    return '';
                            }
                        } else {
                            return '';
                        }
                    },
                    headerSort: false,
                    cellClick: function (e, cell) {
                        const status = cell.getValue();
                        fp.log.verbose({
                            type: 'FixedPricePresenterComponent:StatusCellClick',
                            status
                        });
                        if (status) {
                            switch (status.StatusCode) {
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    fp.ShowError.emit({
                                        open: true,
                                        MsgEntityID: status.MsgEntityID
                                    });
                            }
                        }
                    }
                },
                // 2 Selected
                {
                    title: 'Selected',
                    field: 'selected',
                    headerSort: false,
                    download: false,
                    width: fp.selectColumnWidth,
                    titleFormatter: () =>
                        document.getElementById('cbxColumnHeader'),
                    headerClick: () => {
                        headerClicked = true;

                        const checked = fp.cbxColumnHeader.checked;

                        this.log.debug({
                            type: 'FixedPricePresentersComponent:headerClick',
                            rows: this.tabFixedPrice.getRows(true).length
                        });
                        const rows = fp.tabFixedPrice.getRows(true);

                        rows.forEach(function (row) {
                            if (!checked) {
                                row.select();
                            } else {
                                row.deselect();
                            }
                            row.update({ selected: !checked });
                        });

                        if (!checked) {
                            // TODO: convert this to use css transitions
                            $('#divSelectAll').fadeIn(500);
                        }

                        headerClicked = false;
                    },
                    formatter: 'tickCross',
                    formatterParams: { crossElement: false },
                    editor: false,
                    selectablePersistence: false,
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        row.toggleSelect();
                    }
                },

                // 3 Page Specific Columns
                {
                    title: 'Charge Number / Task',
                    field: 'TaskLongName',
                    cssClass: 'disabled-cursor',
                    minWidth: 200,
                    editor: false
                },
                {
                    title: 'Schedule Date',
                    field: 'ScheduleDate',
                    editor: this.tabService.dateEditor,
                    width: 126,
                    editable: editCheck,
                    formatter: c => {
                        return moment(c.getValue()).isValid()
                            ? moment(c.getValue()).format('MM/DD/YYYY')
                            : '-- Select Date --';
                    },
                    cellEdited: cell => {
                        if (cell.getValue() != '') {
                            const row = cell.getRow();
                            const rowData = row.getData();
                            const data = this.fpinvoices.find(
                                x => x.UniqueID === rowData.UniqueID
                            );
                            const scheduleDate = moment(rowData.ScheduleDate);
                            row.update({
                                Status: { StatusCode: ResponseStatus.Loading }
                            });
                            if (scheduleDate.isValid() === false) {
                                rowData.ScheduleDate = null;
                            } else {
                                rowData.ScheduleDate = moment(
                                    rowData.ScheduleDate
                                ).format('MM-DD-YYYY');
                            }
                            if (rowData.ScheduleDate != null) {
                                row.update({
                                    ...rowData,
                                    ScheduleDate: cell.getValue(),
                                    ModifiedDate: moment(),
                                    Status: {
                                        StatusCode: 1
                                    }
                                });
                                const clone = { ...rowData };
                                this.applyMultiUpdateClicked.emit({
                                    data: clone,
                                    type: 'Single'
                                });
                            } else {
                                alert('You must choose a scheduled date.');
                            }
                        }
                    }
                },
                {
                    title: 'Scheduled Amount',
                    field: 'ScheduledAmount',
                    editor: 'number',
                    width: 140,
                    cellEdited: cell => {
                        if (cell.getValue() != '') {
                            fp.currentCell = cell;
                            const row = cell.getRow();
                            const rowData = row.getData();
                            const data = this.fpinvoices.find(
                                x => x.UniqueID === rowData.UniqueID
                            );
                            const scheduleDate = moment(rowData.ScheduleDate);
                            row.update({
                                Status: { StatusCode: ResponseStatus.Loading }
                            });
                            if (scheduleDate.isValid() === false) {
                                rowData.ScheduleDate = null;
                            } else {
                                rowData.ScheduleDate = moment(
                                    rowData.ScheduleDate
                                ).format('MM-DD-YYYY');
                            }
                            if (rowData.ScheduleDate != null) {
                                const clone = { ...rowData };
                                this.applyMultiUpdateClicked.emit({
                                    data: clone,
                                    type: 'Single'
                                });
                            } else {
                                alert('You must choose a scheduled date.');
                            }
                        }
                    }
                },
                {
                    title: 'Modified Date',
                    field: 'ModifiedDate',
                    width: 126,
                    editor: false,
                    cssClass: 'disabled-cursor',
                    formatter: 'datetime',
                    formatterParams: c => {
                        return { outputFormat: 'MM/DD/YYYY' };
                    }
                },
                {
                    title: 'Invoice Number',
                    field: 'InvoiceNbr',
                    width: 126,
                    cssClass: 'disabled-cursor',
                    editor: false
                },
                {
                    title: 'Invoice Amount',
                    field: 'InvoiceAmount',
                    width: 126,
                    cssClass: 'disabled-cursor',
                    editor: false
                },
                {
                    title: '',
                    field: '',
                    width: fp.selectColumnWidth,
                    editor: false,
                    formatter: () => {
                        return `<i class="pi pi-trash" style="align-items: center; color: red"></i>`;
                    },
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const data = row.getData();
                        fp.confirmservice
                            .confirmPromise({
                                headerText: 'Are you sure?',
                                dialogText:
                                    'This will delete the selected fixed price entry.',
                                okText: 'Yes',
                                cancelText: 'No'
                            })
                            .then(() => {
                                fp.DeleteFixedPrice.next(data);
                            })
                            .catch(() => {});
                    }
                },
                {
                    title: '',
                    field: 'Row_Version',
                    visible: false
                }
            ],
            rowSelected: function (row) {
                row.update({ selected: true });
                if (!headerClicked) {
                    fp.checkIndeterminate();
                }
            },
            rowDeselected: function (row) {
                row.update({ selected: false });
                if (!headerClicked) {
                    fp.checkIndeterminate();
                }
            }
        });
    }

    // Event for toggling task level entry
    public onToggleTaskLevel(e: MatSlideToggleChange) {
        this.log.debug({
            type: 'FixedPriceListComponent:onToggleTaskLevel',
            e
        });
        if (e.checked) {
            this.toggleChecked = true;
            this.taskLevelToggleText = '';
            this.CNTaskDropdownText = 'Charge Numbers & Tasks';
        } else {
            this.toggleChecked = false;
            this.taskLevelToggleText = '';
            this.CNTaskDropdownText = 'Charge Numbers';
        }

        this.toggleTaskLevel.emit(e.checked);
        // this.tabFixedPrice.redraw(true);
    }

    applyUpdates(items: Array<IFixedPrice>) {
        this.log.debug({
            type: 'UserAuthorizationsComponent:applyUpdates',
            items
        });
    }

    public checkIndeterminate() {
        if (this.tabFixedPrice) {
            const rows = this.tabFixedPrice.getRows(true);
            const selectedRows: Array<any> = [];
            rows.forEach(row => {
                if (row._row.data.selected === true) {
                    selectedRows.push(row);
                }
            });

            this.cbxColumnHeader.checked = rows.reduce(
                (a, c) => a && c.getData().selected,
                true
            );
            this.cbxColumnHeader.indeterminate =
                selectedRows.length > 0 &&
                !rows.reduce((a, c) => a && c.getData().selected, true);
        }
    }

    public hasErrorStatus = ued =>
        ued && ued.Status && ued.Status.StatusCode >= DisplayMessageMinimum;

    // Clears any selected rows in the grid
    public clearSelectedFpInvoices() {
        this.tabFixedPrice.deselectRow();
        const data = this.tabFixedPrice.getRows();
        data.forEach(d => {
            d.update({ selected: false });
        });
        this.cbxColumnHeader.checked = false;
        this.checkIndeterminate();
    }

    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.filterFormGroup.controls['startDate'].value;
        ctrlValue.year(normalizedYear.year());
        this.filterFormGroup.controls['startDate'].setValue(ctrlValue);
    }

    chosenMonthHandler(
        normalizedMonth: Moment,
        datepicker: MatDatepicker<Moment>
    ) {
        const ctrlValue = this.filterFormGroup.controls['startDate'].value;
        ctrlValue.month(normalizedMonth.month());
        this.filterFormGroup.controls['startDate'].setValue(ctrlValue);
        datepicker.close();
    }

    chosenDayHandler(normalizedDay: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.filterFormGroup.controls['startDate'].value;
        ctrlValue.month(normalizedDay.day());
        this.filterFormGroup.controls['startDate'].setValue(ctrlValue);
        datepicker.close();
    }

    public clearFilters() {
        this.tabFixedPrice.clearFilter(true);
        this.filterFormGroup.controls['contractTypes'].reset();
        this.filterFormGroup.controls['tasks'].reset();
        this.filterFormGroup.controls['startDate'].patchValue(
            new Date(
                this.startDate
            )
        );
        this.filterFormGroup.controls['endDate'].patchValue(
            new Date(
                this.endDate
            )
        );
    }
}
